import { Tooltip } from "@jugl-web/ui-kit";
import { cx, useAppVariant, useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as UserPencilIcon } from "./assets/user-pencil.svg";

export const ManuallyChangedLogIndicator: FC = () => {
  const { isMobile } = useAppVariant();

  const { t } = useTranslations();

  const iconClassName = cx(
    "flex h-7 w-7 items-center justify-center rounded-lg transition-colors",
    !isMobile && "hover:bg-grey-200 cursor-help"
  );

  if (isMobile) {
    return (
      <div className={iconClassName}>
        <UserPencilIcon />
      </div>
    );
  }

  return (
    <Tooltip
      placement="top"
      className="text-center"
      renderTrigger={({ ref, props }) => (
        <div ref={ref} className={iconClassName} {...props}>
          <UserPencilIcon />
        </div>
      )}
    >
      {t({
        id: "tasks-page.log-mode-manually-created-or-edited",
        defaultMessage: "Manually created or edited log",
      })}
    </Tooltip>
  );
};
